enum VisibilityType {
  allTypes = 1,
  inStoreOnly, // dineInOnly,
  onlineOnly,
  dineInOnly,
  toGoOnly
}

export default VisibilityType
